export var CLEAR_LIVE = 'CLEAR_LIVE';
export var CLEAR_LIVE_MATCH = 'CLEAR_LIVE_MATCH';



// WEBPACK FOOTER //
// ./src/actions/live.js